export default function FixedCta(el, {
    hiddenClass = 'is-hidden',
}) {
    const observer = new IntersectionObserver(([entry]) => {
        el.classList.toggle(hiddenClass, entry.isIntersecting);
    });

    observer.observe(document.querySelector('body > footer'));
}
